<template>
</template>
<script type="text/javascript">
    var q = require('q');
//    var $ = require('jquery');

    var load = function (file) {
        var deferred = q.defer();

        var element = document.createElement('link');
        element.setAttribute('rel', 'stylesheet');
        element.setAttribute('href', file);

        element.onload = element.onreadystatechange = function (e) {
            if (element.readyState && element.readyState !== 'complete' && element.readyState !== 'loaded') {
                return;
            }

            deferred.resolve(element);
        };
        
        element.onerror = function (e) {
            deferred.reject(element);
        };

        $('head').append(element);

        return deferred.promise;
    };

    export default {
        created: function() {
            eventHub.$on('user.profile', function(profile) { this.apply(profile);}.bind(this));
            eventHub.$on('user.logout', function(profile) {this.apply(profile);}.bind(this));
        },
        
        mounted: function(){
            if (typeof this.$root.defaultTheme !== 'undefined') {
                this.defaultTheme = this.$root.defaultTheme.split('/').pop().split('.').shift();
            }

            this.apply(this.$store.state.user);
        },

        data: function() {
            return {
                defaultTheme: 'default',
                currentStylesheet: null
            };
        },

        methods: {
            apply: function(profile) {
                var stylesheet = this.defaultTheme;

                // customised
                if (profile && profile.company && profile.company.data.custom_css) {
                    stylesheet = profile.company.data.custom_css;

                    stylesheet = stylesheet.split('/').pop().split('.').shift();
                }

                if (!__DEV__) {
                    stylesheet = stylesheet + '.' + __webpack_hash__;
                }

                stylesheet = '/assets/theme_' + stylesheet + '.css';

                if (__DEV__) {
                    stylesheet = 'https://dev.multibrain.me:8080' + stylesheet;
                }

                if (!this.currentStylesheet || this.currentStylesheet !== stylesheet) {
                    var oldStylesheet = this.currentStylesheet;

                    eventHub.$emit('loader', load(stylesheet).then(function(element){
                        $('head link[href="' + oldStylesheet + '"]').remove();
                    }).catch(error => {}));

                    this.currentStylesheet = stylesheet;
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/theme.vue